import { Axios } from "services/axios";

export const categoriesApi = {
  fetchAllActiveCategories: async (options = {}) => {
    try {
      const { page = 1, limit = 50, search = '' } = options;
      
      const response = await Axios.fetch('/shop/getAllCategories');
      
      if (!response || !response.data) {
        throw new Error('Invalid response structure from server');
      }

      const categories = response.data.data || response.data || [];
      
      if (!Array.isArray(categories)) {
        throw new Error('Categories data is not in expected format');
      }

      // Filter active categories if needed
      const activeCategories = categories.filter(cat => cat.active !== false);
      
      return activeCategories;
    } catch (error) {
      console.error('Error fetching categories:', error);
      
      let errorMessage = 'Failed to fetch categories';
      
      if (error.response) {
        errorMessage = error.response.data?.message || 
                     `Server error: ${error.response.status}`;
      } else if (error.request) {
        errorMessage = 'Network error: Unable to reach server';
      } else {
        errorMessage = error.message || errorMessage;
      }
      
      throw new Error(errorMessage);
    }
  },

  fetchCategoryById: async (categoryId) => {
    try {
      if (!categoryId) {
        throw new Error('Category ID is required');
      }

      const response = await Axios.fetch(`/shop/getCategoryById/${categoryId}`);
      
      if (!response || !response.data) {
        throw new Error('Invalid response structure from server');
      }

      const category = response.data.data || response.data;
      
      if (!category) {
        throw new Error('Category not found');
      }

      return category;
    } catch (error) {
      console.error('Error fetching category:', error);
      
      let errorMessage = 'Failed to fetch category';
      
      if (error.response) {
        if (error.response.status === 404) {
          errorMessage = 'Category not found';
        } else {
          errorMessage = error.response.data?.message || 
                        `Server error: ${error.response.status}`;
        }
      } else if (error.request) {
        errorMessage = 'Network error: Unable to reach server';
      } else {
        errorMessage = error.message || errorMessage;
      }
      
      throw new Error(errorMessage);
    }
  },

  fetchCategoriesWithProducts: async () => {
    try {
      const response = await Axios.fetch('/shop/getAllCategoriesWithProducts');
      return response.data?.data || [];
    } catch (error) {
      console.error('Error fetching categories with products:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch categories with products');
    }
  }
};
